// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TPublicWebV1GetSearchBannerModel, IMappers, TPublicWebV1GetSearchBannerResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IWebV1GetSearchBanner } from '../../../entities/web_v1_get_search_banner/WebV1GetSearchBanner';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createPublicWebV1GetSearchBannerModel(): TPublicWebV1GetSearchBannerModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'early-access',
    pathApi: '/web/v1/get-search-banner/',
    response: {
      '200': {
        contentType: 'json',
      },
      '400': {
        contentType: 'json',
      },
    },
  };
}

export interface IPublicWebV1GetSearchBannerOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchPublicWebV1GetSearchBanner<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IPublicWebV1GetSearchBannerOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPublicWebV1GetSearchBannerResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicWebV1GetSearchBannerModel(),
    config,
  )) as FetchResponse<TPublicWebV1GetSearchBannerResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IWebV1GetSearchBanner, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPublicWebV1GetSearchBannerResponse>;
}
